module.exports = __webpack_public_path__ + "img/guozai_03.ed50a561.jpg";